import { dayjs } from '../util/dayjs';
import { required } from './required';
export function date(format) {
    return function (value) {
        if (!value)
            return null;
        var m = dayjs(value, format);
        return m.isValid() ? null : 'Enter a valid date';
    };
}
export function requiredDate(format) {
    return required(date(format));
}
//# sourceMappingURL=date.js.map